import { DefaultTheme } from "@react-navigation/native"
import { AmplifyTheme } from "aws-amplify-react-native"
import { palette } from "."

// This is here to remove the weird padding at the top of the screen
export const MyAmplifyTheme = Object.assign({}, AmplifyTheme, {
  container: Object.assign({}, AmplifyTheme.container, {
    flex: 1,
    justifyContent: "center",
    paddingTop: 0,
  }),
})

export const NavigationTheme = {
  ...DefaultTheme,
  colors: {
    ...DefaultTheme.colors,
    background: palette.Background_blue,
  },
}
